export class KiRefreshEvent {
  containerId: string;
  shortened: boolean;

  constructor(containerId: string, shortened: boolean) {
    this.containerId = containerId;
    this.shortened = shortened;
  }
}
